import * as React from 'react';
// @ts-expect-error
import YouTube from 'react-youtube';

// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from '../icon/svg/close-icon';
import {ModalLightbox} from '../modal/modal-lightbox';

import styles from './youtube-modal.module.css';

type Props = {
    onClose: () => void;
    /** Youtube videoId that'll be played when the thumbnail is clicked on */
    /** IMPORTANT: this video must be in the https://www.youtube.com/playlist?list=PLoLQikdPun7d2d3fahIfUni9854Zm1DxS playlist */
    /** because we always reference that playlist in code */
    videoId: string;
};

export function YouTubeModal(props: Props) {
    return (
        <ModalLightbox onClose={props.onClose}>
            <div onClick={props.onClose} className={styles['modal-container']}>
                <button onClick={props.onClose} data-tip='Close'>
                    <CloseIcon size={17} />
                </button>
                <YouTube
                    videoId={props.videoId}
                    opts={{
                        height: '414',
                        width: '736',
                        playerVars: {
                            autoplay: 1,
                            modestbranding: 1,
                            rel: 0,
                        },
                    }}
                />
            </div>
        </ModalLightbox>
    );
}
